export default __webpack_public_path__ + "static/media/hour.8483ff01.svg";